import React from 'react';

export default function Hint( { hint = '' } ) {
    const { info = '', img = '', href = '', linkText = '', target = '', button = '', buttonClick, buttonClassName = '' } = hint;
    return (
        <div className="hint">
            <div className="hint__label">?</div>
            <div className="hint__elem">
                {img ? <img src={img} alt=""/> : ''}
                <span>
                    {info} {href ? <a target={target} href={href}>{linkText}</a> : ''}
                    {button &&
                        <button
                            class={buttonClassName}
                            onClick={buttonClick}
                            type='button'
                        >
                            {button}
                        </button>
                    }
                </span>
            </div>
        </div>
    )
};
